import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_TECHNICAL_ODF = gql`
  mutation deleteTechnicalODF($input: DeleteNodeInput!) {
    deleteTechnicalODF(input: $input)
  }
`;

export const deleteTechnicalODF = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_TECHNICAL_ODF, { input: { propertyId, nodeId } });
};
